/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView";
import ServiceworldHero from "@/src/components/Sections/Generic/ServiceworldHero/ServiceworldHero";

export default function ServiceworldHeroStyleguide() {
  return (
    <StyleguideView fullWidth>
      <ServiceworldHero />
    </StyleguideView>
  );
}
